// src/pages/Patents.jsx
// Public intellectual-property notice page (/patents). Linked from the navbar
// ("Patents") and the footer Legal column ("Intellectual Property"). Shared by
// both brands — the legal entity behind BoardWatch and CityWatch is the same.
import React from 'react';
import './PrivacyPolicy.css'; // Reusing the same CSS for consistency

// Both filings are U.S. provisional applications (35 U.S.C. § 111(b)),
// filed August 2, 2026 — so the accurate public status is "Patent Pending".
const APPLICATIONS = [
  {
    appNumber: '64/124,413',
    title:
      'System and Method for Producing Attributed, Provenance-Graded Response Records ' +
      'from Recordings of Structured Proceedings by Externally-Resolved Respondent ' +
      'Eligibility, Direct-Expression-Constrained Extraction, and Separately-Gated ' +
      'Deterministic Derivation',
  },
  {
    appNumber: '64/124,424',
    title:
      'System and Method for Generating Verifiable Assertions from Unstructured Source ' +
      'Records by Structural Separation of Non-Inferring Extraction from Deterministic ' +
      'Gated Inference, with Provenance-Graded Confidence, Explicit Unresolved States, ' +
      'and Invariance-Tested Aggregation',
  },
];

const Patents = () => (
  <div className="privacy-container">
    <h1>Intellectual Property</h1>

    <p>
      The BoardWatch and CityWatch platforms are protected by the following U.S.
      patent applications:
    </p>

    {APPLICATIONS.map((app) => (
      <section key={app.appNumber}>
        <h2>{app.title}</h2>
        <p>
          <strong>Status:</strong> U.S. Patent Application Pending
        </p>
        <p>
          <strong>Application No.:</strong> {app.appNumber} &nbsp;·&nbsp;{' '}
          <strong>Filed:</strong> August 2026
        </p>
      </section>
    ))}

    <p>
      This page will be updated as these applications progress. Additional
      applications may be pending that are not yet listed here.
    </p>
  </div>
);

export default Patents;
